import { openDB } from "idb";
import { retrieveData } from "./LocalConnection";
import { UpdateDataReservationIndexDB } from "./OfflineConnectionNew";

const DB_NAME = "OfflineFormDataDB";
const DB_VERSION = 12; // Increment version when updating schema
const CategoryManagement = "CategoryManagement";
const GuestInformation = "GuestInformation";
const CustomerOrder = "CustomerOrder";
const CustomerOrderDetail = "CustomerOrderDetail";
const CustomerOrderKOT = "CustomerOrderKOT";
const CustomerOrderKOTDetails = "CustomerOrderKOTDetails";
const CustomerOrderPaymentMode = "CustomerOrderPaymentMode";
const CustomerOrderSpiteBill = "CustomerOrderSpiteBill";
const OpeningBalance = "OpeningBalance";
const ExpenseManagement = "ExpenseManagement";
const MenuManagement = "MenuManagement";
const VariationMenuManagement = "VariationMenuManagement";
const AddonManagement = "AddonManagement";
const AddonMenuManagement = "AddonMenuManagement";
const AddonItemManagement = "AddonItemManagement";
const CobmoMenuManagement = "CobmoMenuManagement";
const FavMenuManagement = "FavMenuManagement";
const RestaurantManagement = "RestaurantManagement";
const StaffManagement = "StaffManagement";
const Dashboard = "Dashboard";
const ReservationInformation = "ReservationInformation";
const DiningAreaTableSetupSetting = "DiningAreaTableSetupSetting";
const SYNC_STORE = "sync";
const SYSTEM_TABLE = "systemtable";
const array_data_base = [
  CategoryManagement,
  OpeningBalance,
  ExpenseManagement,
  MenuManagement,
  VariationMenuManagement,
  AddonManagement,
  AddonItemManagement,
  CobmoMenuManagement,
  FavMenuManagement,
  RestaurantManagement,
  AddonMenuManagement,
  StaffManagement,
  CustomerOrder,
  CustomerOrderDetail,
  GuestInformation,
  CustomerOrderKOT,
  CustomerOrderKOTDetails,
  CustomerOrderPaymentMode,
  CustomerOrderSpiteBill,
  DiningAreaTableSetupSetting,
  SYNC_STORE,
  SYSTEM_TABLE,
  Dashboard,
  ReservationInformation,
];

const initIndexedDB = async (setDbCallback) => {
  const request = indexedDB.open(DB_NAME, DB_VERSION);
  let database;

  request.onupgradeneeded = (event) => {
    database = event.target.result;

    for (const storeName of array_data_base) {
      if (!database.objectStoreNames.contains(storeName)) {
        createObjectStore_DATA(storeName, database);
      }
    }
  };

  request.onsuccess = (event) => {
    setDbCallback(event.target.result);
  };

  request.onerror = (event) => {
    console.error("Error opening IndexedDB:", event.target.error);
  };
};

const initDB = async () => {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(SYNC_STORE)) {
        db.createObjectStore(SYNC_STORE, {
          keyPath: "id",
          autoIncrement: true,
        });
      }
      if (!db.objectStoreNames.contains(SYSTEM_TABLE)) {
        db.createObjectStore(SYSTEM_TABLE, { keyPath: "id" }); // System settings table
      }
    },
  });
};
const openIndexDB = async () => {
  const db = await window.indexedDB.open(DB_NAME, DB_VERSION);

  return new Promise((resolve, reject) => {
    db.onsuccess = () => resolve(db.result);
    db.onerror = (err) => reject(err);
  });
};
const createObjectStore_DATA = (databse_name, database_object) => {
  if (!database_object.objectStoreNames.contains(databse_name)) {
    let store = database_object.createObjectStore(databse_name, {
      keyPath: "id",
      autoIncrement: true,
    });
    if (!store.indexNames.contains("table_no")) {
      if (
        databse_name === CustomerOrder ||
        databse_name === CustomerOrderDetail ||
        databse_name === CustomerOrderKOT ||
        databse_name === CustomerOrderKOTDetails ||
        databse_name === CustomerOrderPaymentMode ||
        databse_name === CustomerOrderSpiteBill
      ) {
        store.createIndex("table_no", "table_no", { unique: false });
        store.createIndex("order_id", "order_id", { unique: false });
      }
      if (databse_name === SYNC_STORE) {
        store.createIndex("table_save_order_id", ["table", "order_id"], {
          unique: false,
        });
      }
      if (databse_name === GuestInformation) {
        store.createIndex("guest_mobile_no", "guest_mobile_no", {
          unique: false,
        });
      }
      if (databse_name === OpeningBalance) {
        store.createIndex("entry_date_only", "entry_date_only", {
          unique: false,
        });
      }
      if (databse_name === ReservationInformation) {
        store.createIndex(
          "unique_key",
          ["book_date", "book_time", "guest_mobile_no"],
          {
            unique: true,
          }
        );
      }
    }
    store.createIndex("flag", "flag", { unique: false });
  }
};

const deleteentryindexdb = async (transaction, storeName, id) => {
  const store = transaction.objectStore(storeName);
  store.delete(id); // Remove item from store when quantity is 0
};

const storeincustomer_data = async (
  transaction,
  storeName,
  data,
  order_id,
  flag
) => {
  try {
    const db = await openGuestDB();

    const tx2 = db.transaction(storeName, "readwrite");
    const store = tx2.objectStore(storeName);
    const index = store.index("order_id");
    let order_id_iiii = order_id;
    if (/^\d+$/.test(order_id_iiii)) {
      order_id_iiii = parseInt(order_id_iiii); // Ensure number type
    } else {
      order_id_iiii = String(order_id_iiii);
    }

    const request = index.getAll(order_id_iiii);
    const records = await new Promise((resolve, reject) => {
      request.onsuccess = () => resolve(request.result);
      request.onerror = (err) => reject(err);
    });

    const foundRecord = records.find(
      (record) => record.order_id === order_id || record.primary_id === order_id
    );
    if (!foundRecord) return null;

    const updateFields = {
      1: [
        "guest_id",
        "guest_name",
        "guest_mobile_no",
        "guest_email",
        "guest_address",
        "guest_locality",
        "guest_gst_no",
        "guest_dob",
        "guest_aniversary",
        "guest_status",
        "amount_of_booking_due",
        "guest_tags",
      ],
      2: ["special_instruction"],
      3: ["no_of_guest"],
      4: [
        "product_amount",
        "tax_per",
        "tax_amount",
        "packing_amount",
        "discount_amount",
        "delivery_amount",
        "tip_amount",
        "roundoff_amount",
        "final_amount",
      ],
      5: ["assign_staff_id"],
      6: ["paid_or_not"],
      7: ["complimentary_table", "complimentary_reason"],
      8: [
        "discount_id",
        "discount_custom_type",
        "discount_code_name",
        "discount_type",
        "discount_reason",
        "discount_amount",
      ],
      10: [
        "payment_mode",
        "payment_description",
        "transaction_id",
        "customer_paid_cash",
        "tip_amount",
        "special_instruction",
        "due_amount_paid",
        "due_amount",
        "pickup_date",
        "pickup_time",
      ],
      11: [
        "current_status",
        "printed_kot_table",
        "printed_table",
        "due_amount",
        "due_amount_paid",
        "order_id",
        "primary_id",
      ],
      12: [
        "dining_area_id",
        "table_code_ids",
        "table_area_name",
        "table_code_names",
        "order_type",
        "table_no",
      ],
      222: [
        "pickup_date",
        "pickup_time",
        "reservation_id",
        "dining_area_id",
        "table_code_ids",
        "table_code_names",
        "table_area_name",
        "product_amount",
        "tax_per",
        "tax_amount",
        "packing_amount",
        "discount_id",
        "discount_code_name",
        "discount_type",
        "discount_custom_type",
        "discount_reason",
        "discount_amount",
        "delivery_amount",
        "tip_amount",
        "roundoff_amount",
        "final_amount",
        "current_status",
        "order_type",
        "special_instruction",
        "remark_cancel",
        "payment_mode",
        "payment_description",
        "transaction_id",
        "entry_date",
        "flag",
      ],
    };

    if (updateFields[flag]) {
      updateFields[flag].forEach((field) => {
        if (data[field] !== undefined) {
          foundRecord[field] =
            field === "entry_date" ? new Date() : data[field];
        }
      });
    }

    const updateRequest = store.put(foundRecord);
    await new Promise((resolve, reject) => {
      updateRequest.onsuccess = () => resolve(foundRecord);
      updateRequest.onerror = (err) => reject(err);
    });

    return foundRecord;
  } catch (error) {
    console.error("Error in storeincustomer_data:", error);
    throw error;
  }
};

const storeincustomer_data_mutiple = (
  transaction,
  storeName,
  data,
  order_id,
  flag
) => {
  return new Promise(async (resolve, reject) => {
    const db = await openGuestDB();

    const tx2 = db.transaction(storeName, "readwrite");
    const store = tx2.objectStore(storeName);

    // Use an indexed lookup instead of fetching all records
    const index = store.index("order_id"); // Ensure this index exists in IndexedDB
    let order_id_iiii = order_id;
    if (/^\d+$/.test(order_id_iiii)) {
      order_id_iiii = parseInt(order_id_iiii); // Ensure number type
    } else {
      order_id_iiii = String(order_id_iiii);
    }
    const request = index.getAll(order_id_iiii); // Fetch records matching order_id

    request.onsuccess = (event) => {
      const matchingRecords = event.target.result;
      console.log(matchingRecords);
      if (matchingRecords.length === 0) {
        return resolve(null); // No matching records found
      }

      let updatedRecords = [];
      matchingRecords.forEach((record) => {
        let updatedDataItem = { ...record, ...data }; // Merge new data
        updatedRecords.push(updatedDataItem);

        const updateRequest = store.put(updatedDataItem); // Update IndexedDB
        updateRequest.onsuccess = () => {
          console.log(
            `Updated Record ID: ${record.primary_id || record.order_id}`
          );
        };
        updateRequest.onerror = (err) => {
          console.error("Update failed:", err);
          reject(err);
        };
      });

      resolve(updatedRecords); // Return updated records
    };

    request.onerror = (err) => {
      console.error("IndexedDB query failed:", err);
      reject(err);
    };
  });
};

const retrieveDataFromObjectStore = (
  dbs,
  storeName,
  table_no = "",
  order_id = "",
  details_wala = "0"
) => {
  return new Promise(async (resolve, reject) => {
    const db = await openGuestDB();
    const transaction = db.transaction(storeName, "readonly");
    const store = transaction.objectStore(storeName);
    let index, keyRange, request;

    // **Determine Index & KeyRange for Efficient Searching**
    if (order_id && order_id !== "0") {
      index = store.index("order_id");
      if (/^\d+$/.test(order_id)) {
        keyRange = IDBKeyRange.only(parseInt(order_id)); // Ensure number type
      } else {
        keyRange = IDBKeyRange.only(String(order_id));
      }
    } else if (table_no) {
      index = store.index("table_no");
      keyRange = IDBKeyRange.only(table_no);
    }

    // **Use getAll() when possible for faster bulk retrieval**
    if (index) {
      request = index.getAll(keyRange); // Faster than opening a cursor if fetching all matching records
    } else {
      request = store.getAll(); // Only use when no indexed search is possible
    }

    request.onsuccess = (event) => {
      let filteredData = event.target.result;
      // console.log(filteredData);
      // **Apply details_wala Filter**
      if (details_wala === "2") {
        filteredData = filteredData.filter(
          (item) => Number(item.current_status) !== 2
        );
      }

      resolve(filteredData);
    };

    request.onerror = (event) => {
      reject(`Error retrieving data from ${storeName}: ${event.target.error}`);
    };
  });
};

const deleteOrderById = (db, storeName, order_id) => {
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(storeName, "readwrite");
    const store = transaction.objectStore(storeName);

    // Get all records first
    const getAllRequest = store.getAll();

    getAllRequest.onsuccess = () => {
      const items = getAllRequest.result;

      // Get all items that match the order_id
      const itemsToDelete = items.filter((item) => item.order_id === order_id);

      if (itemsToDelete.length > 0) {
        let deleteCount = 0;

        itemsToDelete.forEach((item) => {
          const deleteRequest = store.delete(item.id); // Assuming 'id' is the key

          deleteRequest.onsuccess = () => {
            deleteCount++;

            // Resolve when all deletes are done
            if (deleteCount === itemsToDelete.length) {
              resolve();
            }
          };

          deleteRequest.onerror = (event) => {
            console.error(
              `Error deleting order '${order_id}' with ID: ${item.id}`
            );
          };
        });
      } else {
        console.warn(`No orders found with ID '${order_id}'.`);
        resolve();
      }
    };

    getAllRequest.onerror = (event) => {
      reject(`Error fetching data: ${event.target.error}`);
    };
  });
};

// Get System Info
const getSystemInfo = async () => {
  const db = await initDB();
  return db.get(SYSTEM_TABLE, 1); // Assuming single entry with id = 1
};

// Set System Info
const setSystemInfo = async (data) => {
  const db = await initDB();
  const tx = db.transaction(SYSTEM_TABLE, "readwrite");
  const store = tx.objectStore(SYSTEM_TABLE);
  await store.put({ id: 1, ...data }); // Always store under id=1
  await tx.done;
};

// Add to Sync Table
const addToSyncTable = async (data) => {
  const db = await initDB();
  const tx = db.transaction(SYNC_STORE, "readwrite");
  const store = tx.objectStore(SYNC_STORE);

  if (Array.isArray(data.data)) {
    // If data.data is an array, loop through each item
    for (let i = 0; i < data.data.length; i++) {
      const itemToAdd = {
        table: data.table,
        data: data.data[i],
        action: data.action,
        order_id: data.order_id,
      };
      await store.add(itemToAdd);
    }
  } else if (data.data && data.data.length > 0) {
    // Original behavior for non-array data
    await store.add(data);
  }

  await tx.done;
};

// Clear Sync Table after successful sync
const clearSyncTable = async () => {
  const db = await initDB();
  const tx = db.transaction(SYNC_STORE, "readwrite");
  tx.objectStore(SYNC_STORE).clear();
  await tx.done;
};
async function checkInternet() {
  try {
    const response = await fetch("https://www.uprestro.com/favicon.ico", {
      mode: "no-cors",
    });
    return false; // Online
  } catch (error) {
    return false; // Offline
  }
}

const openGuestDB = async () => {
  const db = await window.indexedDB.open(DB_NAME, DB_VERSION);

  return new Promise((resolve, reject) => {
    db.onsuccess = () => resolve(db.result);
    db.onerror = (err) => reject(err);
  });
};

const get_kot_details_bulk_local = async () => {
  const db = await openGuestDB();
  const Flag = "c";
  const tx2 = db.transaction(CustomerOrderKOT, "readonly");
  const store2 = tx2.objectStore(CustomerOrderKOT);
  const index2 = store2.index("flag");
  let kot_orders_final = await new Promise((resolve, reject) => {
    const request = index2.getAll(Flag);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });

  const kot_orders = kot_orders_final.filter(
    (order) =>
      parseInt(order.current_status) !== 2 &&
      parseInt(order.current_status) !== 10
  );

  const tx3 = db.transaction(CustomerOrderKOTDetails, "readonly");
  const store3 = tx3.objectStore(CustomerOrderKOTDetails);
  const index3 = store3.index("flag");
  let kot_details = await new Promise((resolve, reject) => {
    const request = index3.getAll(Flag);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });

  const tx4 = db.transaction(CustomerOrder, "readonly");
  const store4 = tx4.objectStore(CustomerOrder);
  const index4 = store4.index("flag");
  let order_types = await new Promise((resolve, reject) => {
    const request = index4.getAll(Flag);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });

  return {
    data: {
      kot_orders: kot_orders,
      kot_details: kot_details,
      order_types: order_types,
    },
    error: false, // You can add an error flag for better handling
  };
};

const get_order_data_pos_local = async () => {
  const db = await openGuestDB();
  const Flag = "c";
  const tx2 = db.transaction(CustomerOrder, "readonly");
  const store2 = tx2.objectStore(CustomerOrder);
  const index2 = store2.index("flag");
  let data_order = await new Promise((resolve, reject) => {
    const request = index2.getAll(Flag);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });

  data_order.sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));

  const tx3 = db.transaction(CustomerOrderDetail, "readonly");
  const store3 = tx3.objectStore(CustomerOrderDetail);
  const index3 = store3.index("flag");
  let data_order_details = await new Promise((resolve, reject) => {
    const request = index3.getAll(Flag);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });

  const tx4 = db.transaction(CustomerOrderPaymentMode, "readonly");
  const store4 = tx4.objectStore(CustomerOrderPaymentMode);
  const index4 = store4.index("flag");
  let pryment_data = await new Promise((resolve, reject) => {
    const request = index4.getAll(Flag);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });

  return {
    data: {
      message: {
        data_order: data_order,
        data_order_details: data_order_details,
        pryment_data: pryment_data,
      },
    },
    error: false, // You can add an error flag for better handling
  };
};
const get_all_customer_data_pos_local = async () => {
  const db = await openGuestDB();
  const Flag = "c";
  const tx2 = db.transaction(GuestInformation, "readonly");
  const store2 = tx2.objectStore(GuestInformation);
  const index2 = store2.index("flag");
  let data_customer_details = await new Promise((resolve, reject) => {
    const request = index2.getAll(Flag);
    console.log(request);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });
  console.log(data_customer_details);
  return {
    data: {
      message: {
        data_customer_details: data_customer_details,
      },
    },
    error: false, // You can add an error flag for better handling
  };
};
const get_all_sales_report_data_pos_local = async () => {
  const db = await openGuestDB();
  const Flag = "c";
  const tx2 = db.transaction(CustomerOrder, "readonly");
  const store2 = tx2.objectStore(CustomerOrder);
  const index2 = store2.index("flag");
  let kot_orders_final = await new Promise((resolve, reject) => {
    const request = index2.getAll(Flag);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });

  const data_customer_details = kot_orders_final.filter(
    (order) => parseInt(order.due_amount) <= 0
  );

  return {
    data: {
      message: {
        data_customer_details: data_customer_details,
      },
    },
    error: false, // You can add an error flag for better handling
  };
};

const get_all_sales_report_data_pos_local_due = async () => {
  const db = await openGuestDB();
  const Flag = "c";
  const tx2 = db.transaction(CustomerOrder, "readonly");
  const store2 = tx2.objectStore(CustomerOrder);
  const index2 = store2.index("flag");
  let kot_orders_final = await new Promise((resolve, reject) => {
    const request = index2.getAll(Flag);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });

  const data_customer_details = kot_orders_final.filter(
    (order) => parseInt(order.due_amount) > 0
  );

  return {
    data: {
      message: {
        data_customer_details: data_customer_details,
      },
    },
    error: false, // You can add an error flag for better handling
  };
};

//----------Day_End Report-------------------
const day_end_report_data_pos_local = async () => {
  const db = await openGuestDB();
  const Flag = "c";
  const tx2 = db.transaction(Dashboard, "readonly");
  const store2 = tx2.objectStore(Dashboard);
  const index2 = store2.index("flag");
  let day_end_data = await new Promise((resolve, reject) => {
    const request = index2.getAll(Flag);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });

  return {
    data: {
      message: {
        day_end_data: day_end_data,
      },
    },
    error: false, // You can add an error flag for better handling
  };
};

const get_all_tip_report_data_pos_local = async () => {
  const db = await openGuestDB();
  const Flag = "c";

  const tx2 = db.transaction(CustomerOrder, "readonly");
  const store2 = tx2.objectStore(CustomerOrder);
  const index2 = store2.index("flag");
  let data_customer_details = await new Promise((resolve, reject) => {
    const request = index2.getAll(Flag);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });

  const tx3 = db.transaction(StaffManagement, "readonly");
  const store3 = tx3.objectStore(StaffManagement);
  const index3 = store3.index("flag");
  let data_staff_details = await new Promise((resolve, reject) => {
    const request = index3.getAll(Flag);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });

  return {
    data: {
      message: {
        data_customer_details: data_customer_details,
        data_staff_details: data_staff_details,
      },
    },
    error: false, // You can add an error flag for better handling
  };
};

const get_all_table_data_local = async () => {
  const db = await openGuestDB();
  const Flag = "c";
  const tx2 = db.transaction(DiningAreaTableSetupSetting, "readonly");
  const store2 = tx2.objectStore(DiningAreaTableSetupSetting);
  const index2 = store2.index("flag");
  let data_floor = await new Promise((resolve, reject) => {
    const request = index2.getAll(Flag);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });

  const tx3 = db.transaction(CustomerOrder, "readonly");
  const store3 = tx3.objectStore(CustomerOrder);
  const index3 = store3.index("flag");
  let data_order_data = await new Promise((resolve, reject) => {
    const request = index3.getAll(Flag);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });

  const data_order = data_order_data.filter(
    (order) =>
      parseInt(order.current_status) !== 2 &&
      parseInt(order.current_status) !== 10
  );

  const tx4 = db.transaction(CustomerOrderDetail, "readonly");
  const store4 = tx4.objectStore(CustomerOrderDetail);
  const index4 = store4.index("flag");
  let data_order_details = await new Promise((resolve, reject) => {
    const request = index4.getAll(Flag);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });

  const tx5 = db.transaction(CustomerOrderKOT, "readonly");
  const store5 = tx5.objectStore(CustomerOrderKOT);
  const index5 = store5.index("flag");
  let data_kot_final = await new Promise((resolve, reject) => {
    const request = index5.getAll(Flag);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });

  const data_kot = data_kot_final.filter(
    (order) =>
      parseInt(order.current_status) !== 2 &&
      parseInt(order.current_status) !== 10
  );

  const tx6 = db.transaction(CustomerOrderKOTDetails, "readonly");
  const store6 = tx6.objectStore(CustomerOrderKOTDetails);
  const index6 = store6.index("flag");
  let data_kot_details = await new Promise((resolve, reject) => {
    const request = index6.getAll(Flag);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });

  return {
    data: {
      message: {
        data_order: data_order,
        data_floor: data_floor,
        data_order_details: data_order_details,
        data_kot: data_kot,
        data_kot_details: data_kot_details,
      },
    },
    error: false, // You can add an error flag for better handling
  };
};

const submit_data_into_local_kot = async (
  CustomerOrderDetail,
  customerOrderData,
  orderId,
  transaction_call,
  click_from
) => {
  return new Promise(async (resolve, reject) => {
    console.log(CustomerOrderDetail);
    // Fetch existing KOT for the order
    let totalKOTAmount = 0;
    let kot_primary_id = 0;
    const db = await openDB(DB_NAME, DB_VERSION);
    // let existingKOTs = await db.getAll(CustomerOrderKOT);
    // let existingKOT =
    //   existingKOTs.find((kot) => kot.order_id === orderId) || null;
    if (parseInt(click_from) !== 2 && parseInt(click_from) !== 10) {
      const db2 = await openGuestDB();
      const tx = db2.transaction(CustomerOrderKOT, "readonly");
      const store2 = tx.objectStore(CustomerOrderKOT);

      // Use the index to search by order_id
      const index = store2.index("order_id");

      //from kot table
      let existingKOT = await new Promise((resolve, reject) => {
        const request = index.getAll(orderId);
        request.onsuccess = () => resolve(request.result);
        request.onerror = (err) => reject(err);
      });

      // if (customerOrderData[0]?.payment_mode === "Due") {
      //   let customer_id = 0;
      //   let customer_update = "";
      //   const newCustomerEntry = {
      //     primary_id: 0,
      //     guest_name: customerOrderData[0].guest_name,
      //     guest_mobile_no: customerOrderData[0].guest_mobile_no,
      //     guest_email: customerOrderData[0].guest_email,
      //     guest_address: customerOrderData[0].guest_address,
      //     guest_locality: customerOrderData[0].guest_locality,
      //     amount_of_booking_due: customerOrderData[0].final_amount,
      //     guest_status: 1,
      //     entry_date: new Date().toISOString(),
      //     flag: "c",
      //   };
      //   // Add new customer entry
      //   customer_id = await db.add(GuestInformation, newCustomerEntry);

      //   newCustomerEntry.primary_id = customer_id;
      //   newCustomerEntry.id = customer_id;
      //   customer_update = "Add";
      //   // Update record with correct primary_id
      //   console.log("✅ New Customer Added:", newCustomerEntry);
      //   await db.put(GuestInformation, newCustomerEntry);
      // }

      // Fetch existing KOT items Table
      //const existingKOTItems = await db.getAll(CustomerOrderKOTDetails);

      const tx2 = db2.transaction(CustomerOrderKOTDetails, "readonly");
      const store22 = tx2.objectStore(CustomerOrderKOTDetails);
      const index2 = store22.index("order_id");

      //From KOT items Table
      let existingKOTItems = await new Promise((resolve, reject) => {
        const request = index2.getAll(orderId);
        request.onsuccess = () => resolve(request.result);
        request.onerror = (err) => reject(err);
      });
      console.log(existingKOTItems);
      const existingKOTMap = new Map(
        existingKOTItems
          .filter((item) => item.flag !== "d")
          .map((item) => [String(item.id), item])
      );
      console.log(existingKOTMap);
      const newItems = [];
      const updatedItems = [];
      const extraQtyItems = [];
      const deletedItems = [];

      // Convert new order data into a Map
      console.log(CustomerOrderDetail);

      ///provide all data not working correct
      //String(item.id || item.primary_id || "0"),
      const newOrderMap = new Map(
        CustomerOrderDetail.map((item) => [String(item.id), item])
      );
      console.log(newOrderMap);
      // Compare old and new items
      for (const [itemId, existingItem] of existingKOTMap) {
        if (newOrderMap.has(itemId)) {
          const newItem = newOrderMap.get(itemId);
          const newQty = parseInt(newItem.item_qty || "0", 10);
          const existingQty = parseInt(existingItem.item_qty, 10);

          if (newQty < existingQty) {
            existingItem.item_qty = newQty;
            existingItem.total_amount =
              newQty * parseFloat(existingItem.item_discounted_price);
            updatedItems.push(existingItem);
          } else if (newQty > existingQty) {
            extraQtyItems.push({ ...newItem, item_qty: newQty - existingQty });
          }
        } else {
          deletedItems.push({ ...existingItem, flag: "d" });
        }
      }

      // Identify new items
      for (const [itemId, item] of newOrderMap) {
        if (!existingKOTMap.has(itemId)) {
          newItems.push(item);
        }
      }

      // Prevent unnecessary updates
      if (
        !newItems.length &&
        !updatedItems.length &&
        !extraQtyItems.length &&
        !deletedItems.length
      ) {
        console.log("✅ No changes detected, skipping updates.");
        resolve(kot_primary_id);
        return;
      }

      // ✅ Delete items with total_amount = 0
      for (const item of updatedItems) {
        if (parseFloat(item.total_amount) > 0) {
          await db.put(CustomerOrderKOTDetails, item);
        } else {
          console.log(item.id);
          //await db.delete(CustomerOrderKOTDetails, item.id);
          await db.put(CustomerOrderKOTDetails, item);
        }
      }

      for (const item of deletedItems) {
        if (item.id) {
          ///console.log(item.id);
          //await db.delete(CustomerOrderKOTDetails, item.id);
          await db.put(CustomerOrderKOTDetails, item);
        }
      }

      ///return

      if (existingKOT) {
        kot_primary_id = existingKOT.kot_id;
      }
      // ✅ Create a new KOT only if necessary
      if (!existingKOT || extraQtyItems.length > 0 || newItems.length > 0) {
        let kotEntry = {
          kot_id: 0,
          primary_id: 0,
          order_id: orderId,
          kot_number: Date.now(), // Unique KOT Number
          entry_date: new Date().toISOString(),
          total_amount: 0,
          current_status: 1,
          flag: "c",
        };

        kot_primary_id = await db.add(CustomerOrderKOT, kotEntry);
        existingKOT = kotEntry;
        console.log("yes new kot is made");
      } else {
        console.log("no new kot is made");
      }
      // ✅ Insert new items & extra quantities into KOT details
      for (const item of [...newItems]) {
        const newItem = { ...item, kot_id: kot_primary_id };
        //console.log(item);
        await db.put(CustomerOrderKOTDetails, newItem);
        totalKOTAmount += parseFloat(item.total_price_show);
      }

      for (const item of [...extraQtyItems]) {
        //console.log(item);
        const { id, ...ExtraItem } = { ...item, kot_id: kot_primary_id }; // Remove 'id'

        //console.log(ExtraItem);

        await db.put(CustomerOrderKOTDetails, ExtraItem);
        totalKOTAmount += parseFloat(item.total_price_show);
      }

      const tx6 = db.transaction(CustomerOrderKOT, "readwrite");
      const store6 = tx6.objectStore(CustomerOrderKOT);
      const index6 = store6.index("order_id");
      let data_kot_details = await new Promise((resolve, reject) => {
        const request = index6.getAll(orderId);
        request.onsuccess = () => {
          resolve(request.result);
        };
        request.onerror = (err) => {
          console.log(err);
          reject(err);
        };
        resolve(request);
      });
      if (data_kot_details.length > 0) {
        const lastData = { ...data_kot_details[data_kot_details.length - 1] }; // Get the last entry

        // Remove unnecessary fields
        delete lastData.kot_id;
        delete lastData.total_amount;

        // Update with new values
        const ExtraItem = {
          ...lastData,
          kot_id: kot_primary_id,
          primary_id: kot_primary_id,
          total_amount: totalKOTAmount,
        };
        if (parseFloat(totalKOTAmount) > 0) {
          await store6.put(ExtraItem);
        } else {
          await store6.delete(lastData.id);
        }
      }
    }
    if (
      parseInt(click_from) === 11 ||
      parseInt(click_from) === 1 ||
      parseInt(click_from) === 2 ||
      parseInt(click_from) === 10
    ) {
      const tx7 = db.transaction(CustomerOrder, "readwrite");
      const store7 = tx7.objectStore(CustomerOrder);
      const index7 = store7.index("order_id");
      let data_order = await new Promise((resolve, reject) => {
        const request = index7.getAll(orderId);
        request.onsuccess = () => {
          resolve(request.result);
        };
        request.onerror = (err) => {
          console.log(err);
          reject(err);
        };
        resolve(request);
      });
      const filteredData2 = { ...data_order[0] };
      delete filteredData2.current_status;
      delete filteredData2.printed_kot_table;
      const ExtraItem2 = {
        ...filteredData2,
        current_status:
          parseInt(click_from) === 11
            ? 1
            : parseInt(click_from) === 2
            ? 3
            : parseInt(click_from) === 10
            ? 2
            : 1,
        printed_kot_table: parseInt(click_from) === 11 ? 1 : 0,
      };

      await db.put(CustomerOrder, ExtraItem2);
    }
    await add_update_to_sync_table(orderId, 1, {
      kot_primary_id: kot_primary_id,
      order_id: orderId,
    });
    resolve(kot_primary_id);
  });
};

const createKot_from_billing_view = async (order) => {
  try {
    console.log("Order", order);
    const Flag = "c";
    const db = await openGuestDB();

    const tx2 = db.transaction(CustomerOrderDetail, "readwrite");
    const store2 = tx2.objectStore(CustomerOrderDetail);
    const index2 = store2.index("flag");

    const ordersDet = await new Promise((resolve, reject) => {
      const request = index2.getAll(Flag);
      request.onsuccess = () => resolve(request.result);
      request.onerror = (err) => reject(err);
    });

    const matchingOrders = ordersDet.filter(
      (entry) => entry.order_id === order.order_id
    );

    console.log("copalo", matchingOrders);

    await submit_data_into_local_kot(
      matchingOrders,
      order,
      order.order_id,
      "",
      1
    );

    const kotTx = db.transaction("CustomerOrderKOT", "readonly");
    const kotStore = kotTx.objectStore("CustomerOrderKOT");

    const kotsForThisOrder = await new Promise((resolve, reject) => {
      const allRequest = kotStore.getAll();
      allRequest.onsuccess = () => {
        const result = allRequest.result.filter(
          (kot) => kot.order_id === order.order_id
        );
        resolve(result);
      };
      allRequest.onerror = (err) => reject(err);
    });

    console.log("Created KOTs", kotsForThisOrder);

    return true; // ✅ Success
  } catch (error) {
    console.error("Error creating KOT:", error);
    return false; // ❌ Failed
  }
};

const fetch_recent_orders_local = async () => {
  const db = await openGuestDB();
  const Flag = "c";
  const tx2 = db.transaction(CustomerOrder, "readonly");
  const store2 = tx2.objectStore(CustomerOrder);
  const index2 = store2.index("flag");
  let orders = await new Promise((resolve, reject) => {
    const request = index2.getAll(Flag);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });
  orders = orders.filter((order) => ![2, 10].includes(order.current_status));
  orders.sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));

  // Filter Dine-In Orders (order_type = 2)
  const dine_in_orders = orders
    .filter((order) => parseInt(order.order_type) === 3)
    .map(
      ({
        primary_id,
        table_code_names,
        final_amount,
        table_area_name,
        dining_area_id,
        table_code_ids,
        order_type,
        current_status,
      }) => ({
        primary_id,
        table_code_names,
        final_amount,
        table_area_name,
        dining_area_id,
        table_code_ids,
        order_type,
        current_status,
      })
    );

  // Filter Pick-Up Orders (order_type = 1)
  const pick_up_orders = orders
    .filter((order) => parseInt(order.order_type) === 1)
    .map(
      ({
        primary_id,
        table_code_names,
        final_amount,
        table_area_name,
        dining_area_id,
        table_code_ids,
        order_type,
        current_status,
      }) => ({
        primary_id,
        table_code_names,
        final_amount,
        table_area_name,
        dining_area_id,
        table_code_ids,
        order_type,
        current_status,
      })
    );

  const delivery_orders = orders
    .filter((order) => parseInt(order.order_type) === 2)
    .map(
      ({
        primary_id,
        table_code_names,
        final_amount,
        table_area_name,
        dining_area_id,
        table_code_ids,
        order_type,
        current_status,
      }) => ({
        primary_id,
        table_code_names,
        final_amount,
        table_area_name,
        dining_area_id,
        table_code_ids,
        order_type,
        current_status,
      })
    );

  const tx3 = db.transaction(CustomerOrderKOT, "readonly");
  const store3 = tx3.objectStore(CustomerOrderKOT);
  const index3 = store3.index("flag");

  // Fetch all KOT orders where flag = "c"
  let kot_orders = await new Promise((resolve, reject) => {
    const request = index3.getAll(Flag);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });

  // Filter out orders with kot_status 2 and 10
  kot_orders = kot_orders
    .filter((order) => ![2, 10].includes(order.kot_status))
    .map(({ order_id, table_id, total_amount, kot_number }) => ({
      primary_id: order_id,
      table_code_names: table_id,
      final_amount: total_amount,
      kot_number: kot_number,
    }));

  console.log("KOT Orders:", kot_orders);

  return {
    data: {
      dine_in_orders: dine_in_orders,
      pick_up_orders: pick_up_orders,
      delivery_orders: delivery_orders,
      kot_orders: kot_orders,
    },
    error: false, // You can add an error flag for better handling
  };
};

const update_kot_table_cancel = async (
  db,
  kot_primary_id,
  orderId,
  reason,
  kot_status
) => {
  const tx7 = db.transaction(CustomerOrderKOT, "readwrite");
  const store7 = tx7.objectStore(CustomerOrderKOT);
  const index7 = store7.index("order_id");
  let data_order = await new Promise((resolve, reject) => {
    const request = index7.getAll(orderId);
    request.onsuccess = () => {
      resolve(request.result); // Resolving with request.result instead of request
    };
    request.onerror = (err) => {
      console.error("IndexedDB Error:", err);
      reject(err);
    };
  });
  console.log(data_order);
  const data_kot = data_order.filter(
    (order) => parseInt(order.primary_id) === kot_primary_id
  );
  const filteredData2 = { ...data_kot[0] };
  delete filteredData2.kot_status;
  delete filteredData2.current_status;
  delete filteredData2.remark_cancel;
  const ExtraItem2 = {
    ...filteredData2,
    kot_status: kot_status,
    current_status: kot_status,
    remark_cancel: reason,
  };

  await store7.put(ExtraItem2);
  await add_update_to_sync_table(orderId, 3, {
    kot_primary_id: kot_primary_id,
    order_id: orderId,
  });
};

const update_kot_table_complete = async (
  db,
  kot_primary_id,
  orderId,
  kot_status
) => {
  const tx7 = db.transaction(CustomerOrderKOT, "readwrite");
  const store7 = tx7.objectStore(CustomerOrderKOT);
  const index7 = store7.index("order_id");
  let data_order = await new Promise((resolve, reject) => {
    const request = index7.getAll(orderId);
    request.onsuccess = () => {
      resolve(request.result); // Resolving with request.result instead of request
    };
    request.onerror = (err) => {
      console.error("IndexedDB Error:", err);
      reject(err);
    };
  });
  console.log(data_order);
  const data_kot = data_order.filter(
    (order) => parseInt(order.primary_id) === kot_primary_id
  );
  const filteredData2 = { ...data_kot[0] };
  delete filteredData2.kot_status;
  const ExtraItem2 = {
    ...filteredData2,
    kot_status: kot_status,
  };

  await store7.put(ExtraItem2);
  await add_update_to_sync_table(orderId, 3, {
    kot_primary_id: kot_primary_id,
    order_id: orderId,
  });
};

const update_balance_amount = async (entry_date_only, billAmount) => {
  const db = await openGuestDB();
  const tx7 = db.transaction(OpeningBalance, "readwrite");
  const store7 = tx7.objectStore(OpeningBalance);
  const index7 = store7.index("entry_date_only");
  let balance_update = "Add";
  let balance_id = "0";
  let data_balance = await new Promise((resolve, reject) => {
    const request = index7.getAll(entry_date_only);
    request.onsuccess = () => {
      resolve(request.result); // Resolving with request.result instead of request
    };
    request.onerror = (err) => {
      reject(err);
    };
  });

  if (data_balance && data_balance.length > 0) {
    let opening_balance_drawer =
      data_balance[0].opening_balance_drawer + billAmount;
    let opening_balance = data_balance[0].opening_balance;
    const filteredData2 = { ...data_balance[0] };
    delete filteredData2.opening_balance_drawer;
    delete filteredData2.opening_balance;
    const ExtraItem2 = {
      ...filteredData2,
      opening_balance_drawer: opening_balance_drawer,
      opening_balance: opening_balance,
    };
    await store7.put(ExtraItem2);
    balance_update = "Update";
    balance_id = data_balance[0].primary_id;
  } else {
    const retrievedAdminId = retrieveData("admin_id");
    const retrievedRestaurantId = retrieveData("default_restaurant_id");
    const admin_name = retrieveData("admin_name");
    const newBalanceEntry = {
      primary_id: 0,
      entry_date: new Date().toISOString(),
      day_end_date: null,
      entry_date_only: entry_date_only,
      day_end_date_only: null,
      restaurant_id: retrievedRestaurantId,
      opening_admin_id: retrievedAdminId,
      opening_admin_name: admin_name,
      admin_id: 0,
      close_admin_name: null,
      opening_balance: billAmount,
      opening_comments: null,
      opening_balance_drawer: billAmount,
      closing_balance: 0.0,
      closing_balance_drawer: 0.0,
      closing_comments: null,
      flag: "c", // New Entry
    };
    // Add new customer entry
    balance_id = await new Promise((resolve, reject) => {
      const addRequest = store7.add(newBalanceEntry);
      addRequest.onsuccess = (event) => resolve(event.target.result);
      addRequest.onerror = (err) => reject(err);
    });

    // Update newCustomerEntry with the generated primary_id
    newBalanceEntry.primary_id = balance_id;
    newBalanceEntry.id = balance_id;
    balance_update = "Add";
    await store7.put(newBalanceEntry);
  }
  await add_update_to_sync_table(entry_date_only, 5, {
    entry_date_only: entry_date_only,
    update_status: balance_update,
    balance_id: balance_id,
  });
};

const discard_order_hold = async (db, orderId, current_status) => {
  const tx7 = db.transaction(CustomerOrder, "readwrite");
  const store7 = tx7.objectStore(CustomerOrder);
  const index7 = store7.index("order_id");
  let data_order = await new Promise((resolve, reject) => {
    const request = index7.getAll(orderId);
    request.onsuccess = () => {
      resolve(request.result); // Resolving with request.result instead of request
    };
    request.onerror = (err) => {
      console.error("IndexedDB Error:", err);
      reject(err);
    };
  });

  const filteredData2 = { ...data_order[0] };
  delete filteredData2.current_status;
  const ExtraItem2 = {
    ...filteredData2,
    current_status: current_status,
  };

  await store7.put(ExtraItem2);
  await add_update_to_sync_table(orderId, 4, {
    order_id: orderId,
  });
};

const cancel_order_complete = async (
  db,
  orderId,
  current_status,
  remark_cancel
) => {
  const tx7 = db.transaction(CustomerOrder, "readwrite");
  const store7 = tx7.objectStore(CustomerOrder);
  const index7 = store7.index("order_id");
  let data_order = await new Promise((resolve, reject) => {
    const request = index7.getAll(orderId);
    request.onsuccess = () => {
      resolve(request.result); // Resolving with request.result instead of request
    };
    request.onerror = (err) => {
      console.error("IndexedDB Error:", err);
      reject(err);
    };
  });

  const filteredData2 = { ...data_order[0] };
  delete filteredData2.current_status;
  delete filteredData2.remark_cancel;
  const ExtraItem2 = {
    ...filteredData2,
    current_status: current_status,
    remark_cancel: remark_cancel,
  };

  await store7.put(ExtraItem2);
  await add_update_to_sync_table(orderId, 4, {
    order_id: orderId,
  });
};

const cancel_kot_complete = async (
  db,
  orderId,
  kot_primary_id,
  current_status,
  kot_status
) => {
  const tx7 = db.transaction(CustomerOrderKOT, "readwrite");
  const store7 = tx7.objectStore(CustomerOrderKOT);
  const index7 = store7.index("order_id");
  let data_order = await new Promise((resolve, reject) => {
    const request = index7.getAll(orderId);
    request.onsuccess = () => {
      resolve(request.result); // Resolving with request.result instead of request
    };
    request.onerror = (err) => {
      console.error("IndexedDB Error:", err);
      reject(err);
    };
  });

  const data_kot = data_order.filter(
    (order) => parseInt(order.primary_id) === kot_primary_id
  );
  console.log(data_kot);
  console.log(data_order);
  const filteredData2 = { ...data_kot[0] };
  delete filteredData2.current_status;
  delete filteredData2.kot_status;
  const ExtraItem2 = {
    ...filteredData2,
    current_status: current_status,
    kot_status: kot_status,
  };

  await store7.put(ExtraItem2);
  await add_update_to_sync_table(orderId, 3, {
    kot_primary_id: kot_primary_id,
    order_id: orderId,
  });
};

const get_all_kot_data_pos_local = async () => {
  const db = await openGuestDB();
  const Flag = "c";
  const tx2 = db.transaction(CustomerOrder, "readonly");
  const store2 = tx2.objectStore(CustomerOrder);
  const index2 = store2.index("flag");
  let data_order = await new Promise((resolve, reject) => {
    const request = index2.getAll(Flag);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });
  data_order.sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));

  const tx3 = db.transaction(CustomerOrderDetail, "readonly");
  const store3 = tx3.objectStore(CustomerOrderDetail);
  const index3 = store3.index("flag");
  let data_order_details = await new Promise((resolve, reject) => {
    const request = index3.getAll(Flag);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });
  data_order_details.sort(
    (a, b) => new Date(b.entry_date) - new Date(a.entry_date)
  );

  const tx4 = db.transaction(CustomerOrderKOT, "readonly");
  const store4 = tx4.objectStore(CustomerOrderKOT);
  const index4 = store4.index("flag");
  let data_kot = await new Promise((resolve, reject) => {
    const request = index4.getAll(Flag);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });
  data_kot.sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));

  const tx5 = db.transaction(CustomerOrderKOTDetails, "readonly");
  const store5 = tx5.objectStore(CustomerOrderKOTDetails);
  const index5 = store5.index("flag");
  let data_kot_details = await new Promise((resolve, reject) => {
    const request = index5.getAll(Flag);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });
  data_kot_details.sort(
    (a, b) => new Date(b.entry_date) - new Date(a.entry_date)
  );

  return {
    data: {
      message: {
        data_order: data_order,
        data_order_details: data_order_details,
        data_kot: data_kot,
        data_kot_details: data_kot_details,
      },
    },
    error: false, // You can add an error flag for better handling
  };
};

const get_all_kot_active = async () => {
  const db = await openGuestDB();
  const Flag = "c";

  const tx4 = db.transaction(CustomerOrderKOT, "readonly");
  const store4 = tx4.objectStore(CustomerOrderKOT);
  const index4 = store4.index("flag");
  let data_kot = await new Promise((resolve, reject) => {
    const request = index4.getAll(Flag);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });

  let active_data = 0;
  data_kot.forEach((kot) => {
    if (parseInt(kot.current_status) === 1) {
      active_data = 1;
    }
  });

  return {
    data: {
      message: {
        active_data: active_data,
        data_kot: data_kot,
      },
      error: false, // You can add an error flag for better handling
    },
  };
};

const get_last_take_delivery = async () => {
  const db = await openGuestDB();
  const Flag = "c";

  const tx4 = db.transaction(CustomerOrder, "readonly");
  const store4 = tx4.objectStore(CustomerOrder);
  const index4 = store4.index("flag");
  let data_kot = await new Promise((resolve, reject) => {
    const request = index4.getAll(Flag);
    request.onsuccess = () => resolve(request.result);
    request.onerror = (err) => reject(err);
  });

  let last_order_id_delivery = 0;
  let last_order_id_take = 0;
  data_kot.forEach((kot) => {
    if (parseInt(kot.current_status) === 0 && parseInt(kot.order_type) === 2) {
      last_order_id_delivery = kot.id;
    }
    if (parseInt(kot.current_status) === 0 && parseInt(kot.order_type) === 1) {
      last_order_id_take = kot.id;
    }
  });

  return {
    data: {
      message: {
        last_order_id_delivery: last_order_id_delivery,
        last_order_id_take: last_order_id_take,
      },
      error: false, // You can add an error flag for better handling
    },
  };
};

const submit_data_into_local = async (
  customer_order_data_console,
  billSettle,
  click_from,
  transaction_callaaa,
  orderId
) => {
  try {
    const db11 = await openGuestDB();
    const transaction_call = db11.transaction(array_data_base, "readwrite");
    let primary_id = 0;
    let primary_payment = 0;
    let reservation_id = 0;
    let book_date = "";
    let book_time = "";
    let guest_mobile_no_rese = "";
    if (customer_order_data_console && customer_order_data_console[0]) {
      primary_id = customer_order_data_console[0].id;
      primary_payment = customer_order_data_console[0].final_amount;
      reservation_id = customer_order_data_console[0].reservation_id;
      book_date = customer_order_data_console[0]?.book_date;
      book_time = customer_order_data_console[0]?.book_time;
      guest_mobile_no_rese =
        customer_order_data_console[0]?.guest_mobile_no_rese;
    }
    let current_status = 2;
    let printed_kot_table = 0;
    let printed_table = 0;

    if (parseInt(billSettle) === 0) {
      current_status = 0;

      if (parseInt(billSettle) === 3) {
        current_status = 3;
      }
      if (parseInt(billSettle) === 2) {
        current_status = 2;
      }

      if (parseInt(click_from) === 11) {
        printed_kot_table = 1;
      }
      if (parseInt(click_from) === 10) {
        printed_table = 1;
      }
    }

    const db = await openDB(DB_NAME, DB_VERSION);

    const existingCustomerOrder = await db.get(
      CustomerOrder,
      parseInt(orderId)
    );

    // Check if customer already exists using mobile number
    const existingPayment = await db.getAllFromIndex(
      CustomerOrderPaymentMode,
      "order_id",
      parseInt(orderId)
    );

    let payment_id = 0;
    let no_entry = 0;
    if (!existingPayment || existingPayment.length === 0) {
      const retrievedAdminId = retrieveData("admin_id");
      const retrievedRestaurantId = retrieveData("default_restaurant_id");
      const modifiedDataItem = {
        order_id: parseInt(orderId), // Ensure primary_id is stored as id
        restaurant_id: retrievedRestaurantId,
        admin_id: retrievedAdminId,
        entry_date: new Date().toISOString(),
        payment_mode: existingCustomerOrder.payment_mode,
        payment_amount: primary_payment,
        guest_id: 0,
        payment_comment: "",
        data_type: "online",
        flag: "c",
      };
      // Add new customer entry
      payment_id = await db.add(CustomerOrderPaymentMode, modifiedDataItem);
      no_entry = 1;
      // Update newCustomerEntry with the generated primary_id
      modifiedDataItem.primary_id = payment_id;
      modifiedDataItem.id = payment_id;
      // Update record with correct primary_id
      await db.put(CustomerOrderPaymentMode, modifiedDataItem);
    }
    let total_amount_paid = 0;
    let due_amount = 0;
    let total_cash = parseFloat(primary_payment);
    existingPayment.forEach((item) => {
      total_amount_paid += parseFloat(item.payment_amount);
      // Update record with correct primary_id
      if (item.payment_mode === "Due") {
        due_amount += parseFloat(item.payment_amount);
      }
    });
    if (
      parseFloat(total_amount_paid) !== parseFloat(primary_payment) &&
      no_entry === 0
    ) {
      total_cash = parseFloat(primary_payment) - parseFloat(total_amount_paid);
      const retrievedAdminId = retrieveData("admin_id");
      const retrievedRestaurantId = retrieveData("default_restaurant_id");
      const modifiedDataItem = {
        order_id: parseInt(orderId), // Ensure primary_id is stored as id
        restaurant_id: retrievedRestaurantId,
        admin_id: retrievedAdminId,
        entry_date: new Date().toISOString(),
        payment_mode: "Cash",
        payment_amount: total_cash,
        guest_id: 0,
        payment_comment: "",
        data_type: "online",
        flag: "c",
      };
      // Add new customer entry
      payment_id = await db.add(CustomerOrderPaymentMode, modifiedDataItem);

      // Update newCustomerEntry with the generated primary_id
      modifiedDataItem.primary_id = payment_id;
      modifiedDataItem.id = payment_id;
      // Update record with correct primary_id
      await db.put(CustomerOrderPaymentMode, modifiedDataItem);
    }

    if (existingCustomerOrder.payment_mode === "Due") {
      due_amount = parseFloat(primary_payment);
      total_cash = 0;
    }

    // Parse JSON data
    let customer_id = 0;
    let customer_update = "";
    let customer_mobile_no = "";
    if (
      customer_order_data_console?.length > 0 &&
      customer_order_data_console[0]?.guest_mobile_no
    ) {
      customer_mobile_no = customer_order_data_console[0].guest_mobile_no;
    }
    console.log(customer_order_data_console[0]);
    if (billSettle === 2) {
      if (
        customer_order_data_console[0]?.guest_mobile_no !== "" &&
        customer_order_data_console[0]?.guest_name !== "" &&
        customer_order_data_console[0]?.guest_mobile_no !== undefined &&
        customer_order_data_console[0]?.guest_name !== undefined
      ) {
        // Check if customer already exists using mobile number
        const existingCustomers = await db.getAllFromIndex(
          GuestInformation,
          "guest_mobile_no",
          customer_order_data_console[0]?.guest_mobile_no
        );
        const retrievedRestaurantId = retrieveData("default_restaurant_id");
        if (!existingCustomers || existingCustomers.length === 0) {
          // Create new Customer record if it doesn't exist
          const newCustomerEntry = {
            primary_id: 0,
            guest_name: customer_order_data_console[0].guest_name,
            guest_mobile_no: customer_order_data_console[0].guest_mobile_no,
            guest_email: customer_order_data_console[0].guest_email,
            guest_address: customer_order_data_console[0].guest_address,
            guest_locality: customer_order_data_console[0].guest_locality,
            guest_status: 1,
            restaurant_id: retrievedRestaurantId,
            amount_of_booking_due: parseFloat(due_amount),
            entry_date: new Date().toISOString(),
            flag: "c",
          };
          // Add new customer entry
          customer_id = await db.add(GuestInformation, newCustomerEntry);

          // Update newCustomerEntry with the generated primary_id
          newCustomerEntry.primary_id = customer_id;
          newCustomerEntry.id = customer_id;
          customer_update = "Add";
          // Update record with correct primary_id
          console.log("✅ New Customer Added:", newCustomerEntry);
          await db.put(GuestInformation, newCustomerEntry);
        } else {
          // Update existing customer record
          const existingCustomer = existingCustomers[0]; // Get first matching record
          existingCustomer.guest_name =
            customer_order_data_console[0].guest_name;
          existingCustomer.guest_email =
            customer_order_data_console[0].guest_email;
          existingCustomer.guest_address =
            customer_order_data_console[0].guest_address;
          existingCustomer.guest_locality =
            customer_order_data_console[0].guest_locality;
          existingCustomer.amount_of_booking_due += parseFloat(due_amount);
          existingCustomer.guest_status = 1;
          existingCustomer.entry_date = new Date().toISOString(); // Update timestamp
          customer_update = "Update";
          // Update record in IndexedDB
          await db.put(GuestInformation, existingCustomer);
          customer_id = existingCustomer.primary_id;
          console.log("✅ Existing Customer Updated:", existingCustomer);
        }
      }

      await storeincustomer_data(
        transaction_call,
        CustomerOrder,
        {
          current_status: current_status,
          printed_kot_table: printed_kot_table,
          due_amount: due_amount,
          due_amount_paid: total_cash,
          printed_table: printed_table,
          ...(primary_id !== 0 && { order_id: primary_id }), // ✅ Correct syntax
          ...(primary_id !== 0 && { primary_id: primary_id }), // ✅ Correct syntax
        },
        parseInt(orderId),
        11
      );
      await storeincustomer_data_mutiple(
        transaction_call,
        CustomerOrderDetail,
        {
          current_status: current_status,
          ...(primary_id !== 0 && { order_id: primary_id }), // ✅ Correct syntax
        },
        parseInt(orderId),
        12
      );
      // await storeincustomer_data_mutiple(
      //   transaction_call,
      //   CustomerOrderKOT,
      //   {
      //     current_status: current_status,
      //     ...(primary_id !== 0 && { order_id: primary_id }), // ✅ Correct syntax
      //   },
      //   parseInt(orderId),
      //   12
      // );
      // await storeincustomer_data_mutiple(
      //   transaction_call,
      //   CustomerOrderKOTDetails,
      //   {
      //     current_status: current_status,
      //     ...(primary_id !== 0 && { order_id: primary_id }), // ✅ Correct syntax
      //   },
      //   parseInt(orderId),
      //   12
      // );
      await storeincustomer_data_mutiple(
        transaction_call,
        CustomerOrderPaymentMode,
        {
          guest_id: customer_id,
          ...(primary_id !== 0 && { order_id: primary_id }), // ✅ Correct syntax
        },
        parseInt(orderId),
        12
      );
    }
    await add_update_to_sync_table(primary_id, 2, {
      order_id: primary_id,
      customer_id: customer_id,
      customer_mobile_no: customer_mobile_no,
      customer_update: customer_update,
      billSettle: billSettle,
    });
    console.log(reservation_id);
    if (current_status === 2 && reservation_id !== 0) {
      const existing = await db.getAllFromIndex(
        ReservationInformation,
        "unique_key",
        [book_date, book_time, guest_mobile_no_rese]
      );
      console.log([book_date, book_time, guest_mobile_no_rese]);
      if (existing && existing[0]) {
        await UpdateDataReservationIndexDB(db, existing[0], {
          booking_status: 3,
          payout_amt: primary_payment,
          invoice_no_bill: primary_id,
        });
      }
    }
  } catch (error) {
    console.error("Error processing order:", error);
  }
};

const add_update_to_sync_table = async (order_id, flag, extra_data) => {
  const db = await initDB();
  if (flag === 1 || flag === 2) {
    const tx1 = db.transaction(CustomerOrder, "readwrite");
    const store1 = tx1.objectStore(CustomerOrder);

    const index1 = store1.index("order_id");
    console.log("order_id", flag);
    let data_order = await new Promise((resolve, reject) => {
      const request = index1.getAll(order_id);
      request.onsuccess = () => {
        resolve(request.result); // Resolving with request.result instead of request
      };
      request.onerror = (err) => {
        console.error("IndexedDB Error:", err);
        reject(err);
      };
      resolve(request);
    });
    let data_check = await check_sync_table_data_present_or_not(
      db,
      CustomerOrder,
      order_id
    );

    // if (extra_data.billSettle) {
    //   if (extra_data.billSettle === 2 && data_check === "Add") {
    //     data_check = "Update";
    //   }
    // }

    // Track update in sync table
    await addToSyncTable({
      table: CustomerOrder,
      data: data_order,
      action: data_check,
      order_id: order_id,
    });

    const tx2 = db.transaction(CustomerOrderDetail, "readwrite");
    const store2 = tx2.objectStore(CustomerOrderDetail);
    const index2 = store2.index("order_id");
    let data_order_details = await new Promise((resolve, reject) => {
      const request = index2.getAll(order_id);
      request.onsuccess = () => {
        resolve(request.result); // Resolving with request.result instead of request
      };
      request.onerror = (err) => {
        console.error("IndexedDB Error:", err);
        reject(err);
      };
      resolve(request);
    });

    let data_check2 = await check_sync_table_data_present_or_not(
      db,
      CustomerOrderDetail,
      order_id
    );

    // if (extra_data.billSettle) {
    //   if (extra_data.billSettle === 2 && data_check2 === "Add") {
    //     data_check2 = "Update";
    //   }
    // }

    if (data_order_details && data_order_details.length > 0) {
      // Track update in sync table
      await addToSyncTable({
        table: CustomerOrderDetail,
        data: data_order_details,
        action: data_check2,
        order_id: order_id,
      });
    }

    const tx3 = db.transaction(CustomerOrderKOT, "readwrite");
    const store3 = tx3.objectStore(CustomerOrderKOT);
    const index3 = store3.index("order_id");
    let data_order_kot = await new Promise((resolve, reject) => {
      const request = index3.getAll(order_id);
      request.onsuccess = () => {
        resolve(request.result); // Resolving with request.result instead of request
      };
      request.onerror = (err) => {
        console.error("IndexedDB Error:", err);
        reject(err);
      };
      resolve(request);
    });

    let data_check3 = await check_sync_table_data_present_or_not(
      db,
      CustomerOrderKOT,
      order_id
    );

    // if (extra_data.billSettle) {
    //   if (extra_data.billSettle === 2 && data_check3 === "Add") {
    //     data_check3 = "Update";
    //   }
    // }

    if (data_order_kot && data_order_kot.length > 0) {
      // Track update in sync table
      await addToSyncTable({
        table: CustomerOrderKOT,
        data: data_order_kot,
        action: data_check3,
        order_id: order_id,
      });
    }

    const tx4 = db.transaction(CustomerOrderKOTDetails, "readwrite");
    const store4 = tx4.objectStore(CustomerOrderKOTDetails);
    const index4 = store4.index("order_id");
    let data_order_kot_detail = await new Promise((resolve, reject) => {
      const request = index4.getAll(order_id);
      request.onsuccess = () => {
        resolve(request.result); // Resolving with request.result instead of request
      };
      request.onerror = (err) => {
        console.error("IndexedDB Error:", err);
        reject(err);
      };
      resolve(request);
    });

    let data_check4 = await check_sync_table_data_present_or_not(
      db,
      CustomerOrderKOTDetails,
      order_id
    );

    // if (extra_data.billSettle) {
    //   if (extra_data.billSettle === 2 && data_check4 === "Add") {
    //     data_check4 = "Update";
    //   }
    // }

    // Track update in sync table
    if (data_order_kot_detail && data_order_kot_detail.length > 0) {
      await addToSyncTable({
        table: CustomerOrderKOTDetails,
        data: data_order_kot_detail,
        action: data_check4,
        order_id: order_id,
      });
    }
    if (flag === 2) {
      const tx5 = db.transaction(CustomerOrderPaymentMode, "readwrite");
      const store5 = tx5.objectStore(CustomerOrderPaymentMode);
      const index5 = store5.index("order_id");
      let data_order_payment_detail = await new Promise((resolve, reject) => {
        const request = index5.getAll(order_id);
        request.onsuccess = () => {
          resolve(request.result); // Resolving with request.result instead of request
        };
        request.onerror = (err) => {
          console.error("IndexedDB Error:", err);
          reject(err);
        };
        resolve(request);
      });

      let data_check5 = await check_sync_table_data_present_or_not(
        db,
        CustomerOrderPaymentMode,
        order_id
      );

      // Track update in sync table
      await addToSyncTable({
        table: CustomerOrderPaymentMode,
        data: data_order_payment_detail,
        action: data_check5,
        order_id: order_id,
      });

      for (let i = 0; i < data_order_payment_detail.length; i++) {
        if (data_order_payment_detail[i].payment_mode === "Cash") {
          update_balance_amount(
            new Date(data_order_payment_detail[i].entry_date)
              .toISOString()
              .split("T")[0],
            parseFloat(data_order_payment_detail[i].payment_amount)
          );
        }
      }

      if (extra_data.customer_id !== 0) {
        const tx6 = db.transaction(GuestInformation, "readwrite");
        const store6 = tx6.objectStore(GuestInformation);
        const index6 = store6.index("guest_mobile_no");
        let data_order_guest = await new Promise((resolve, reject) => {
          const request = index6.getAll(extra_data.customer_mobile_no);
          request.onsuccess = () => {
            resolve(request.result); // Resolving with request.result instead of request
          };
          request.onerror = (err) => {
            console.error("IndexedDB Error:", err);
            reject(err);
          };
          resolve(request);
        });

        if (extra_data.billSettle) {
          if (extra_data.billSettle === 2 && data_order_guest === "Add") {
            data_order_guest = "Update";
          }
        }

        // Track update in sync table
        await addToSyncTable({
          table: GuestInformation,
          data: data_order_guest,
          action: extra_data.customer_update,
          order_id: order_id,
        });
      }
    }
  } else if (flag === 3) {
    const tx5 = db.transaction(CustomerOrderKOT, "readwrite");
    const store5 = tx5.objectStore(CustomerOrderKOT);
    const index5 = store5.index("order_id");
    let data_order_payment_detail = await new Promise((resolve, reject) => {
      const request = index5.getAll(order_id);
      request.onsuccess = () => {
        resolve(request.result); // Resolving with request.result instead of request
      };
      request.onerror = (err) => {
        console.error("IndexedDB Error:", err);
        reject(err);
      };
      resolve(request);
    });

    data_order_payment_detail = data_order_payment_detail.filter(
      (item) => Number(item.primary_id) === extra_data.kot_primary_id
    );

    // Track update in sync table
    await addToSyncTable({
      table: CustomerOrderKOT,
      data: data_order_payment_detail,
      action: "update",
      order_id: order_id,
    });
  } else if (flag === 4) {
    const tx1 = db.transaction(CustomerOrder, "readwrite");
    const store1 = tx1.objectStore(CustomerOrder);

    const index1 = store1.index("order_id");
    console.log("order_id", flag);
    let data_order = await new Promise((resolve, reject) => {
      const request = index1.getAll(order_id);
      request.onsuccess = () => {
        resolve(request.result); // Resolving with request.result instead of request
      };
      request.onerror = (err) => {
        console.error("IndexedDB Error:", err);
        reject(err);
      };
      resolve(request);
    });

    // Track update in sync table
    await addToSyncTable({
      table: CustomerOrder,
      data: data_order,
      action: "update",
      order_id: order_id,
    });
  } else if (flag === 5) {
    const tx1 = db.transaction(OpeningBalance, "readwrite");
    const store1 = tx1.objectStore(OpeningBalance);

    const index1 = store1.index("entry_date_only");
    let data_order = await new Promise((resolve, reject) => {
      const request = index1.getAll(order_id);
      request.onsuccess = () => {
        resolve(request.result); // Resolving with request.result instead of request
      };
      request.onerror = (err) => {
        console.error("IndexedDB Error:", err);
        reject(err);
      };
      resolve(request);
    });
    // console.log("ddddd", data_order);
    // Track update in sync table
    await addToSyncTable({
      table: OpeningBalance,
      data: data_order,
      action: extra_data.update_status,
      order_id: extra_data.balance_id,
    });
  } else if (flag === 6) {
    if (extra_data.customer_id !== 0) {
      const tx6 = db.transaction(GuestInformation, "readwrite");
      const store6 = tx6.objectStore(GuestInformation);
      const index6 = store6.index("guest_mobile_no");
      let data_order_guest = await new Promise((resolve, reject) => {
        const request = index6.getAll(extra_data.customer_mobile_no);
        request.onsuccess = () => {
          resolve(request.result); // Resolving with request.result instead of request
        };
        request.onerror = (err) => {
          console.error("IndexedDB Error:", err);
          reject(err);
        };
        resolve(request);
      });

      // Track update in sync table
      await addToSyncTable({
        table: GuestInformation,
        data: data_order_guest,
        action: extra_data.customer_update,
        order_id: order_id,
      });
    }
  } else if (flag === 7) {
    const tx6 = db.transaction(ReservationInformation, "readwrite");
    const store6 = tx6.objectStore(ReservationInformation);
    console.log(extra_data);
    const index1 = store6.index("unique_key");
    const keyRange = IDBKeyRange.only([
      extra_data.book_date,
      extra_data.book_time,
      extra_data.guest_mobile_no,
    ]);
    let data_order = await new Promise((resolve, reject) => {
      const request = index1.getAll(keyRange);
      request.onsuccess = () => {
        resolve(request.result); // Resolving with request.result instead of request
      };
      request.onerror = (err) => {
        console.error("IndexedDB Error:", err);
        reject(err);
      };
      resolve(request);
    });

    // Track update in sync table
    await addToSyncTable({
      table: ReservationInformation,
      data: data_order,
      action: extra_data.customer_update,
      order_id: order_id,
    });
  }
  // console.log("complete");
};

const check_sync_table_data_present_or_not = async (
  db,
  data_table,
  order_id
) => {
  const tx1 = db.transaction(SYNC_STORE, "readwrite");
  const store1 = tx1.objectStore(SYNC_STORE);

  const index1 = store1.index("table_save_order_id");
  const keyRange = IDBKeyRange.only([data_table, order_id]);
  let data_order = await new Promise((resolve, reject) => {
    const request = index1.getAll(keyRange);
    request.onsuccess = () => {
      resolve(request.result); // Resolving with request.result instead of request
    };
    request.onerror = (err) => {
      console.error("IndexedDB Error:", err);
      reject(err);
    };
    resolve(request);
  });
  // console.log(data_order.length);
  if (data_order.length === 0) {
    return "Add";
  }
  return "Update";
};

const submit_split_order_into_local = async (
  customer_order_data_details_data,
  orderId,
  transaction_call,
  click_from,
  itemSplit
) => {
  return new Promise(async (resolve, reject) => {
    const db = await openDB(DB_NAME, DB_VERSION);
    if (parseInt(click_from) !== 2 && parseInt(click_from) !== 10) {
      const db2 = await openGuestDB();
      const tx8 = db2.transaction(array_data_base, "readwrite");
      const store9 = tx8.objectStore(CustomerOrder);
      const store8 = tx8.objectStore(CustomerOrder);
      const store11 = tx8.objectStore(CustomerOrderDetail);
      const index8 = store8.index("order_id");
      const index11 = store11.index("order_id");
      let finalOrdersArray = [];

      let customerOrderData = await new Promise((resolve, reject) => {
        const request = index8.getAll(orderId);
        request.onsuccess = () => {
          resolve(request.result);
        };
        request.onerror = (err) => {
          reject(err);
        };
      });
      let customerOrderDataDetails = await new Promise((resolve, reject) => {
        const request = index11.getAll(orderId);
        request.onsuccess = () => {
          resolve(request.result);
        };
        request.onerror = (err) => {
          reject(err);
        };
      });

      if (customerOrderDataDetails.length > 0) {
        console.log(customerOrderDataDetails);
      }
      if (customerOrderData.length > 0) {
        const mappedArray = itemSplit.orders.map((order) => [
          order.bill_id,
          order.items[0].item_name,
          order.items[0].item_price,
        ]);

        let baseOrder = customerOrderData[0];

        if (baseOrder) {
          // **1. Pehla order update karein**
          let firstItem = mappedArray[0]; // Pehla mapped item le rahe
          if (firstItem) {
            baseOrder.product_amount = parseFloat(firstItem[2]); // Update price
            baseOrder.final_amount =
              parseFloat(firstItem[2]) + parseFloat(firstItem[2]) * 0.05; // Add 5% tax
            baseOrder.tax_amount = parseFloat(firstItem[2]) * 0.05;
          }

          // **DB UPDATE: Pehla order update ho raha hai original order_id se**
          await store9.put(baseOrder);
          finalOrdersArray.push(baseOrder);
        }

        // **2. Baki ke naye orders insert karein WITHOUT order_id**
        for (let i = 1; i < mappedArray.length; i++) {
          let [itemPrice] = mappedArray[i];

          let newOrder = { ...baseOrder };

          // **Remove order_id before inserting**
          delete newOrder.order_id;
          delete newOrder.primary_id;
          delete newOrder.id;

          // **Update price-related fields**
          newOrder.product_amount = itemPrice;
          newOrder.final_amount = itemPrice + itemPrice * 0.05; // Adding 5% tax
          newOrder.tax_amount = itemPrice * 0.05;

          // **DB INSERT: Naye orders insert ho rahe hai bina order_id ke**
          let new_id = await db.add(CustomerOrder, newOrder);
          if (new_id) {
            if (new_id) {
              newOrder.primary_id = new_id;
              newOrder.order_id = new_id;
              newOrder.id = new_id;
              await db.put(CustomerOrder, newOrder);
              finalOrdersArray.push(newOrder);
            }
          }
        }
      }

      // Loop through customerOrderDataDetails to update order_id
      for (let i = 0; i < customerOrderDataDetails.length; i++) {
        let orderDetail = { ...customerOrderDataDetails[i] };
        let orderData = { ...finalOrdersArray[i] };
        // If it's NOT the base order, update order_id
        if (i !== 0) {
          orderDetail.order_id = orderData.primary_id;
        }

        // submit_data_into_local_kot(
        //   [orderDetail],
        //   "",
        //   orderData.primary_id,
        //   transaction_call,
        //   click_from
        // );

        // Update the database with the modified details
        await db.put(CustomerOrderDetail, orderDetail);
      }
      resolve(orderId);
    }
  });
};

const submit_percentage_split_order_into_local = async (
  customer_order_data_details_data,
  orderId,
  transaction_call,
  click_from,
  percentageSplit
) => {
  return new Promise(async (resolve, reject) => {
    const db = await openDB(DB_NAME, DB_VERSION);
    if (parseInt(click_from) !== 2 && parseInt(click_from) !== 10) {
      const db2 = await openGuestDB();
      const tx = db2.transaction(array_data_base, "readwrite");
      const storeOrders = tx.objectStore(CustomerOrder);
      const storeDetails = tx.objectStore(CustomerOrderDetail);
      const indexOrders = storeOrders.index("order_id");
      const indexDetails = storeDetails.index("order_id");

      // Fetch base order details
      let customerOrderData = await new Promise((resolve, reject) => {
        const request = indexOrders.getAll(orderId);
        request.onsuccess = () => resolve(request.result);
        request.onerror = (err) => reject(err);
      });

      let customerOrderDataDetails = await new Promise((resolve, reject) => {
        const request = indexDetails.getAll(orderId);
        request.onsuccess = () => resolve(request.result);
        request.onerror = (err) => reject(err);
      });

      if (customerOrderData.length === 0) return reject("No order data found");

      let baseOrder = { ...customerOrderData[0] };
      let finalOrdersArray = [];

      // Process each percentage split
      for (let i = 0; i < percentageSplit.length; i++) {
        let splitPercentage = percentageSplit[i] / 100;
        let newOrder = { ...baseOrder };

        newOrder.product_amount = (
          baseOrder.product_amount * splitPercentage
        ).toFixed(2);
        newOrder.final_amount = (
          parseFloat(newOrder.product_amount) +
          parseFloat(newOrder.product_amount) * 0.05
        ).toFixed(2);
        newOrder.tax_amount = (newOrder.product_amount * 0.05).toFixed(2);
        newOrder.quantity = (baseOrder.quantity * splitPercentage).toFixed(2);

        // Ensure values are stored as numbers, not strings
        newOrder.product_amount = parseFloat(newOrder.product_amount);
        newOrder.final_amount = parseFloat(newOrder.final_amount);
        newOrder.tax_amount = parseFloat(newOrder.tax_amount);
        newOrder.quantity = parseFloat(newOrder.quantity);

        if (i === 0) {
          // First split updates base order
          await storeOrders.put(newOrder);
          finalOrdersArray.push(newOrder);
        } else {
          delete newOrder.order_id;
          delete newOrder.primary_id;
          delete newOrder.id;

          let newId = await db.add(CustomerOrder, newOrder);
          if (newId) {
            newOrder.primary_id = newId;
            newOrder.order_id = newId;
            newOrder.id = newId;
            await db.put(CustomerOrder, newOrder);
            finalOrdersArray.push(newOrder);
          }
        }
      }

      // Process customerOrderDataDetails
      for (let i = 0; i < finalOrdersArray.length; i++) {
        let orderData = finalOrdersArray[i];

        for (let j = 0; j < customerOrderDataDetails.length; j++) {
          let originalDetail = customerOrderDataDetails[j]; // Original entry
          let newDetail = { ...originalDetail }; // Clone original entry

          if (i === 0) {
            // Update existing base orderDataDetails entry
            newDetail.item_qty =
              originalDetail.item_qty * (percentageSplit[i] / 100);
            newDetail.total_price_show = orderData.final_amount;
            await db.put(CustomerOrderDetail, newDetail);
          } else {
            // Create new entries for new orders
            delete newDetail.id;
            await db.add(CustomerOrderDetail, {
              ...newDetail,
              order_id: orderData.primary_id, // Assigning new order_id
              item_qty: originalDetail.item_qty * (percentageSplit[i] / 100),
              total_price_show: orderData.final_amount,
            });

            // if (newDetailId) {
            //   submit_data_into_local_kot(
            //     [newDetail],
            //     orderData.primary_id,
            //     transaction_call,
            //     click_from
            //   );
            // }
          }
        }
      }

      resolve(orderId);
    }
  });
};

const submit_portion_split_order_into_local = async (
  customer_order_data_details_data,
  orderId,
  transaction_call,
  click_from,
  selectedPortion
) => {
  // console.log("jhahjahjjhasdhjsahdashjashjshkasjsajkahhasdhjsadjh");
  return new Promise(async (resolve, reject) => {
    const db = await openDB(DB_NAME, DB_VERSION);
    if (parseInt(click_from) !== 2 && parseInt(click_from) !== 10) {
      const db2 = await openGuestDB();
      const tx = db2.transaction(array_data_base, "readwrite");
      const storeOrders = tx.objectStore(CustomerOrder);
      const storeDetails = tx.objectStore(CustomerOrderDetail);
      const indexOrders = storeOrders.index("order_id");
      const indexDetails = storeDetails.index("order_id");

      // Fetch base order details
      let customerOrderData = await new Promise((resolve, reject) => {
        const request = indexOrders.getAll(orderId);
        request.onsuccess = () => resolve(request.result);
        request.onerror = (err) => reject(err);
      });

      let customerOrderDataDetails = await new Promise((resolve, reject) => {
        const request = indexDetails.getAll(orderId);
        request.onsuccess = () => resolve(request.result);
        request.onerror = (err) => reject(err);
      });

      if (customerOrderData.length === 0) return reject("No order data found");

      let baseOrder = { ...customerOrderData[0] };
      let finalOrdersArray = [];

      // Calculate equal split factor
      let portionFactor = 1 / selectedPortion; // Divide into equal portions

      // Process each portion
      for (let i = 0; i < selectedPortion; i++) {
        let newOrder = { ...baseOrder };

        newOrder.product_amount = baseOrder.product_amount * portionFactor;
        newOrder.final_amount =
          newOrder.product_amount + newOrder.product_amount * 0.05;
        newOrder.tax_amount = newOrder.product_amount * 0.05;
        newOrder.quantity = baseOrder.quantity * portionFactor;

        if (i === 0) {
          // First split updates base order
          await storeOrders.put(newOrder);
          finalOrdersArray.push(newOrder);
        } else {
          delete newOrder.order_id;
          delete newOrder.primary_id;
          delete newOrder.id;

          let newId = await db.add(CustomerOrder, newOrder);
          if (newId) {
            newOrder.primary_id = newId;
            newOrder.order_id = newId;
            newOrder.id = newId;
            await db.put(CustomerOrder, newOrder);
            finalOrdersArray.push(newOrder);
          }
        }
      }

      // Process customerOrderDataDetails
      for (let i = 0; i < finalOrdersArray.length; i++) {
        let orderData = finalOrdersArray[i];

        for (let j = 0; j < customerOrderDataDetails.length; j++) {
          let originalDetail = customerOrderDataDetails[j]; // Original entry
          let newDetail = { ...originalDetail }; // Clone original entry

          let calculatedQty = (originalDetail.item_qty * portionFactor).toFixed(
            2
          );
          let calculatedPrice = orderData.final_amount.toFixed(2);

          // Ensure values are stored as numbers
          calculatedQty = parseFloat(calculatedQty);
          calculatedPrice = parseFloat(calculatedPrice);

          if (i === 0) {
            // Update existing base orderDataDetails entry
            newDetail.item_qty = calculatedQty;
            newDetail.total_price_show = calculatedPrice;
            await db.put(CustomerOrderDetail, newDetail);
          } else {
            // Create new entries for new orders
            delete newDetail.id;
            delete newDetail.primary_id;

            const modifiedDataItem = {
              ...newDetail,
              order_id: orderData.primary_id, // Assigning new order_id
              item_qty: calculatedQty,
              total_price_show: calculatedPrice,
            };

            let newDetailId = await db.add(
              CustomerOrderDetail,
              modifiedDataItem
            );
            if (newDetailId) {
              modifiedDataItem.primary_id = newDetailId;
              modifiedDataItem.id = newDetailId;
              // Update record with correct primary_id
              await db.put(CustomerOrderDetail, modifiedDataItem);
            }
          }
        }
      }

      resolve(orderId);
    }
  });
};

const saveReservation = async (reservation_data) => {
  // const db = await openIndexDB();
  const db = await openDB(DB_NAME, DB_VERSION);
  console.log("reservation_data", reservation_data);
  try {
    // Check if a reservation with same book_date, book_time, and mobile exists
    const existing = await db.getAllFromIndex(
      ReservationInformation,
      "unique_key",
      [
        reservation_data.book_date,
        reservation_data.operational_booking_time,
        reservation_data.guest_mobile_no,
      ]
    );
    // console.log("existing", existing);
    if (existing.length > 0) {
      console.log("Duplicate reservation — Not saving.");
      return { success: false, message: "Duplicate reservation" };
    } else {
      let customer_id = 0;
      let customer_new_old = 0;
      const existingCustomers = await db.getAllFromIndex(
        GuestInformation,
        "guest_mobile_no",
        reservation_data.guest_mobile_no
      );

      if (!existingCustomers || existingCustomers.length === 0) {
        const retrievedRestaurantId = retrieveData("default_restaurant_id");
        // Create new Customer record if it doesn't exist
        const newCustomerEntry = {
          primary_id: 0,
          guest_name: reservation_data.guest_name,
          guest_mobile_no: reservation_data.guest_mobile_no,
          guest_email: reservation_data.guest_email,
          guest_address: "",
          guest_locality: "",
          guest_status: 1,
          restaurant_id: retrievedRestaurantId,
          amount_of_booking_due: 0,
          entry_date: new Date().toISOString(),
          flag: "c",
        };
        // Add new customer entry
        customer_id = await db.add(GuestInformation, newCustomerEntry);
        customer_new_old = 1;
        // Update newCustomerEntry with the generated primary_id
        newCustomerEntry.primary_id = customer_id;
        newCustomerEntry.id = customer_id;
        await db.put(GuestInformation, newCustomerEntry);
      } else {
        // Update existing customer record
        const existingCustomer = existingCustomers[0]; // Get first matching record
        customer_id = existingCustomer.primary_id;
      }
      reservation_data.guest_id = customer_id;
      let note_intruction = 0;
      if (
        reservation_data.reservation_comment !== "" &&
        reservation_data.reservation_comment !== null
      ) {
        note_intruction = 1;
      }
      const retrievedRestaurantId = retrieveData("default_restaurant_id");
      const reservation = {
        primary_id: 0,
        actual_date: new Date().toISOString(),
        entry_date: new Date().toISOString(),
        restaurant_id: retrievedRestaurantId,
        operational_time_detail_id: 0,
        counter_invoice: "",
        book_date: reservation_data.book_date,
        book_time: reservation_data.operational_booking_time,
        book_discount: "0",
        guest_id: reservation_data.guest_id,
        guest_name: reservation_data.guest_name,
        guest_mobile_no: reservation_data.guest_mobile_no,
        guest_email: reservation_data.guest_email,
        guest_gender: "",
        guest_dob: null,
        guest_status: 0,
        no_of_guest: reservation_data.no_of_guest,
        no_of_pets: 0,
        no_of_child: 0,
        reservation_otp: 123456,
        reservation_description: reservation_data.reservation_comment,
        note_intruction: note_intruction,
        invoice_no_bill: "",
        payout_amt: 0,
        payment_type: "",
        arrival_time: null,
        no_show_time: null,
        cancel_time: null,
        release_time: null,
        update_date: new Date().toISOString(),
        notify_flag: 0,
        booking_type: 3,
        booking_status: 0,
        no_show_status: 0,
        auto_manual: 0,
        special_day_status: 0,
        customer_new_old: customer_new_old,
        dining_area_id: 0,
        table_code_ids: "",
        table_code_names: "",
        total_table_combine: 0,
        table_alloted: 0,
        last_reservation_date: null,
        avg_reservation_duration: 0,
        booking_from: "POS",
        firebase_token: "",
        booking_reminder_sent: 0,
        flag: "c",
      };
      let primary_id = await db.add(ReservationInformation, reservation);

      reservation.primary_id = primary_id;
      reservation.counter_invoice = primary_id;
      reservation.id = primary_id;
      await db.put(ReservationInformation, reservation);

      if (customer_new_old === 0) {
        await add_update_to_sync_table(reservation_data.guest_id, 6, {
          order_id: reservation_data.guest_id,
          customer_id: reservation_data.guest_id,
          customer_mobile_no: reservation_data.guest_mobile_no,
          customer_update: "Add",
        });
      }

      await add_update_to_sync_table(primary_id, 7, {
        order_id: primary_id,
        book_date: reservation_data.book_date,
        book_time: reservation_data.operational_booking_time,
        guest_mobile_no: reservation_data.guest_mobile_no,
        customer_update: "Add",
      });

      console.log("Reservation saved.");
      return { success: true };
    }
  } catch (error) {
    console.error("Error saving reservation:", error);
    return { success: false, error };
  }
};

export {
  DB_NAME,
  DB_VERSION,
  AddonItemManagement,
  AddonManagement,
  AddonMenuManagement,
  array_data_base,
  CategoryManagement,
  CobmoMenuManagement,
  CustomerOrderDetail,
  CustomerOrderKOT,
  CustomerOrderKOTDetails,
  CustomerOrder,
  CustomerOrderSpiteBill,
  CustomerOrderPaymentMode,
  DiningAreaTableSetupSetting,
  ExpenseManagement,
  FavMenuManagement,
  GuestInformation,
  MenuManagement,
  OpeningBalance,
  RestaurantManagement,
  SYNC_STORE,
  SYSTEM_TABLE,
  VariationMenuManagement,
  StaffManagement,
  ReservationInformation,
  initDB,
  openIndexDB,
  addToSyncTable,
  initIndexedDB,
  getSystemInfo,
  deleteOrderById,
  retrieveDataFromObjectStore,
  setSystemInfo,
  checkInternet,
  clearSyncTable,
  storeincustomer_data,
  storeincustomer_data_mutiple,
  submit_data_into_local,
  submit_data_into_local_kot,
  deleteentryindexdb,
  get_all_table_data_local,
  submit_split_order_into_local,
  submit_percentage_split_order_into_local,
  get_all_kot_data_pos_local,
  fetch_recent_orders_local,
  get_kot_details_bulk_local,
  get_order_data_pos_local,
  get_all_customer_data_pos_local,
  update_kot_table_cancel,
  update_kot_table_complete,
  discard_order_hold,
  get_all_sales_report_data_pos_local,
  get_all_tip_report_data_pos_local,
  day_end_report_data_pos_local,
  cancel_order_complete,
  cancel_kot_complete,
  update_balance_amount,
  submit_portion_split_order_into_local,
  get_all_kot_active,
  get_last_take_delivery,
  saveReservation,
  add_update_to_sync_table,
  createKot_from_billing_view,
  get_all_sales_report_data_pos_local_due,
};
